(ns common.schema.entities.counterparty-diligence.templates.validation
  (:require
   [common.util :as cu]
   [clojure.string :as string]
   [common.schema.entities.counterparty-diligence.templates.util :as tu]))

;; TODO: add other mandatoriness if needed, :mandatory/conditional etc.

(defn validate-text-field
  [{:keys [field-config]} value]
  (let [{:keys [mandatoriness]} field-config]
    (case mandatoriness
      :mandatory/optional
      (when-not (or (nil? value)
                    (string? value))
        :validation.error/invalid-data-type)

      :mandatory/always
      (cond
        (nil? value)
        :validation.error/field-required

        (not (string? value))
        :validation.error/invalid-data-type

        (-> value
            string/trim
            cu/blank-value?)
        :validation.error/field-required))))

(defn validate-keyword-single-field
  [{:keys [field-config]} value]
  (let [{:keys [mandatoriness options]} field-config
        valid-option? (->> options
                           (filterv (fn [opt]
                                      (= (or (:value opt)
                                             (:key opt))
                                         value)))
                           seq)]
    (case mandatoriness
      :mandatory/optional
      (cond
        (nil? value)
        nil

        (not (keyword? value))
        :validation.error/invalid-data-type

        (not valid-option?)
        :validation.error/invalid-option)

      :mandatory/always
      (cond
        (nil? value)
        :validation.error/field-required

        (not (keyword? value))
        :validation.error/invalid-data-type

        (not valid-option?)
        :validation.error/invalid-option))))

(defn valid-attachment-ids?
  [entity-lookup attachment-ids]
  (->> attachment-ids
       (mapv entity-lookup)
       (every? (fn [attachment]
                 (and attachment
                      (= (:entity/type attachment) :entity.type/attachment)
                      (not (:common/disabled? attachment)))))))

(defn validate-file-field
  [{:keys [field-config entity-lookup]} value]
  (let [{:keys [mandatoriness multiple?]} field-config
        attachment-ids (cond
                         (sequential? value) value
                         (nil? value) []
                         :else [value])
        valid-attachments? (valid-attachment-ids? entity-lookup attachment-ids)]
    (case mandatoriness
      :mandatory/optional
      (cond
        (empty? attachment-ids)
        nil

        (not valid-attachments?)
        :validation.error/invalid-file-value

        (and (not multiple?)
             (->> attachment-ids
                  count
                  (< 1)))
        :validation.error/only-one-file-allowed)

      :mandatory/always
      (cond
        (empty? attachment-ids)
        :validation.error/field-required

        (not valid-attachments?)
        :validation.error/invalid-file-value

        (and (not multiple?)
             (->> attachment-ids
                  count
                  (< 1)))
        :validation.error/only-one-file-allowed))))

;; TODO: add value range validation if needed
(defn validate-date-field
  [{:keys [field-config]} value]
  (let [{:keys [mandatoriness]} field-config]
    (case mandatoriness
      :mandatory/optional
      (when-not (or (nil? value)
                    (integer? value))
        :validation.error/invalid-data-type)

      :mandatory/always
      (cond
        (nil? value)
        :validation.error/field-required

        (not (integer? value))
        :validation.error/invalid-data-type))))

;; TODO: Add validation min/max item count if needed
(defn validate-vector-field
  [{:keys [field-config entity-lookup validate-fields e-signature-required? draft? lang-kw] :as args} value]
  (let [{:keys [item-data-type item-template min-items max-items min-items-error max-items-error]} field-config
        min-items (if (fn? min-items)
                    (min-items (assoc args :value value))
                    min-items)
        max-items (if (fn? max-items)
                    (max-items (assoc args :value value))
                    max-items)]
    (cond
      (and draft?
           (cu/empty-value? value))
      nil

      (not (or (vector? value)
               (nil? value)))
      {:general :validation.error/invalid-data-type}

      ;; TODO: add more item types as needed
      :else
      (case item-data-type
        :data.type/map
        (if-not (every? map? value)
          {:general :validation.error/invalid-item-data-type}
          (let [item-count (count value)
                too-few-items? (and (int? min-items)
                                    (< item-count min-items))
                too-many-items? (and (int? max-items)
                                     (< max-items item-count))
                general (cond (and (not draft?)
                                   too-few-items?)
                              (or min-items-error :validation.error/too-few-items)
                              (and (not draft?)
                                   too-many-items?)
                              (or max-items-error :validation.error/too-many-items))
                item-errors (->> value
                                 (mapv (fn [item]
                                         (let [errors (validate-fields
                                                       {:data item
                                                        :template item-template
                                                        :e-signature-required? e-signature-required?
                                                        :entity-lookup entity-lookup
                                                        :lang-kw lang-kw
                                                        :draft? draft?})]
                                           errors))))
                item-errors? (->> item-errors
                                  (remove nil?)
                                  seq)]
            (when (or general
                      item-errors?)
              (merge {}
                     (when general
                       {:general general})
                     (when item-errors?
                       {:items item-errors})))))))))

(defn resolve-mandatoriness
  [{:keys [field-config _data draft?] :as args}]
  (cond
    draft?
    :mandatory/optional

    (-> field-config
        :mandatoriness
        (= :mandatory/when-visible))
    (if (tu/field-visible? args)
      :mandatory/always
      :mandatory/optional)

    (:mandatoriness field-config)
    (:mandatoriness field-config)

    :else :mandatory/always))

(defn validate-field
  [{:keys [field field-config data _draft?] :as args}]
  (let [{:keys [data-type validation-fn]} field-config
        mandatoriness (resolve-mandatoriness args)
        field-config (assoc field-config :mandatoriness mandatoriness)
        args (assoc args :field-config field-config)
        value (get data field)
        ;; TODO: add more data types as needed
        error-or-errors (if (fn? validation-fn)
                          (validation-fn (assoc args
                                                :field field
                                                :value value))
                          (case data-type
                            :data.type/text-simple (validate-text-field args value)
                            :data.type/text-multiline (validate-text-field args value)
                            :data.type/keyword (validate-keyword-single-field args value)
                            :data.type/file (validate-file-field args value)
                            :data.type/date (validate-date-field args value)
                            :data.type/vector (validate-vector-field args value)
                            (do
                              (println "NO MATCHING CLAUSE " data-type ": " args)
                              (throw (ex-info "No matching cause" {:data-type data-type})))))

        errors (cond
                 (map? error-or-errors)
                 (when (or (:general error-or-errors)
                           (->> error-or-errors
                                :items
                                (remove nil?)
                                seq))
                   error-or-errors)

                 (sequential? error-or-errors)
                 (->> error-or-errors
                      (remove cu/blank-value?)
                      vec)

                 error-or-errors
                 [error-or-errors])]
    (when (seq errors)
      errors)))

(defn validate-fields
  [{:keys [data template e-signature-required? entity-lookup lang-kw draft?]
    :or {lang-kw :en}}]
  (let [field-errors (->> template
                          :template/schema
                          (mapv (fn [[field field-config]]
                                  (let [validation-errors (validate-field
                                                           {:data data
                                                            :field field
                                                            :field-config field-config
                                                            :entity-lookup entity-lookup
                                                            :validate-fields validate-fields
                                                            :lang-kw lang-kw
                                                            :draft? draft?
                                                            :e-signature-required? e-signature-required?})]
                                    [field validation-errors])))
                          (remove (fn [[_field validation-errors]]
                                    (not validation-errors)))
                          (into {}))]
    (when (seq field-errors)
      field-errors)))
